import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";

customerAddressFormFieldStyles.phoneGridItem = {
    width: 12,
};
